import React, { useState, useEffect, useRef } from 'react';
import '../styles/team.css';

function TeamCard({ member, isRandomCard, triggerFlip, setHasFlippedOnce }) {
  const [isFlipped, setIsFlipped] = useState(false);

  useEffect(() => {
    if (isRandomCard && triggerFlip) {
      // Trigger quick flip for the random card
      setIsFlipped(true);
      const timeout = setTimeout(() => {
        setIsFlipped(false); // Reset flip after animation duration
        setHasFlippedOnce(true); // Prevent further scroll-triggered flips
      }, 800); // Matches CSS transition duration (0.8s)
      return () => clearTimeout(timeout);
    }
  }, [isRandomCard, triggerFlip, setHasFlippedOnce]);

  const handleClick = () => {
    // Allow flipping on click/tap
    setIsFlipped(!isFlipped);
  };

  return (
    <div className={`team-card ${isFlipped ? 'flipped' : ''}`} onClick={handleClick}>
      <div className="team-card-inner">
        <div className="team-card-front">
          <img src={member.img} alt={member.name} />
          <div className="team-card-overlay"></div>
        </div>
        <div className="team-card-back">
          <div className="team-card-back-content">
            <h3>{member.name}</h3>
            <p>{member.role}</p>
            <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

function TeamSection() {
  const [randomCardIndex, setRandomCardIndex] = useState(null);
  const [triggerFlip, setTriggerFlip] = useState(false);
  const [hasFlippedOnce, setHasFlippedOnce] = useState(false);
  const sectionRef = useRef(null);

  const teamMembers = [
    {
      img: "/arvand.png",
      name: "Arvand Azadvar",
      role: "Leads Rust nodes and P2P stack: PQC handshakes, proofs engines, rollups/DA clients, storage triads, resource caps/backpressure; co-designs consensus and data models.",
      linkedin: "https://www.linkedin.com/in/arvand-azadvar/",
    },
    {
      img: "/artit.jpg",
      name: "Artit Muhaxhiri",
      role: "Leads vision and product roadmap; hands-on development across protocol specs (PoC, PoRep, PoSt, DRS), Urego smart contracts, and node UX.",
      linkedin: "https://www.linkedin.com/in/artit-muhaxhiri-b7749923a/",
    },
    {
      img: "/dat.png",
      name: "Dat Huynh",
      role: "Building the Erlang/OTP L1: consensus (HotStuff/Tendermint-style), headers/QCs/receipts, UDS gRPC bridge to Rust node, DRS server and payouts, PoC/PoSt event ingestion, device attestation allowlist, DeployPolicy system contract, metrics/logging and ops.",
      linkedin: "https://www.linkedin.com/in/dat-huynh-1a1aa5156/",
    },
  ];

  useEffect(() => {
    if (randomCardIndex === null) {
      setRandomCardIndex(Math.floor(Math.random() * teamMembers.length));
    }
  
    const currentSection = sectionRef.current;
  
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasFlippedOnce) {
          setTriggerFlip(true);
        }
      },
      { threshold: 0.5 }
    );
  
    if (currentSection) {
      observer.observe(currentSection);
    }
  
    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, [randomCardIndex, hasFlippedOnce, teamMembers.length]);
  

  return (
    <section id="team" className="team container mx-auto px-4" ref={sectionRef}>
      <h2 className="text-3xl font-bold mb-8">Meet The Team</h2>
      <div className="team-grid">
        {teamMembers.map((member, i) => (
          <TeamCard
            key={i}
            member={member}
            isRandomCard={i === randomCardIndex}
            triggerFlip={triggerFlip}
            setHasFlippedOnce={setHasFlippedOnce}
          />
        ))}
      </div>
    </section>
  );
}

export default TeamSection;